import React from 'react';
import { GroupProps, profileType } from '../GroupItem/GroupItem';
import LeftArrow from '../../../assets/Left 1.svg';
import './GroupDetails.css'; // Importing the external CSS file
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import { Box, Typography } from '@mui/material';
import DataUnavailable from '../../../components/DataUnavailable';

type Props = {
  goBack: () => void;
  groupInfo: GroupProps | null;
};

const GroupDetails: React.FC<Props> = ({ groupInfo, goBack }) => {
  return (
    <StyledBgContainer>
      <Box
        sx={{
          px: { xs: 2, sm: 10 },
          py: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px 24px',
          color: 'white',
        }}
      >
        {/* Back Arrow */}
        <img src={LeftArrow} onClick={goBack} alt="Back icon" />

        {/* Centered Title */}
        <Typography
          variant="h6"
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            fontWeight: 'bold',
          }}
        >
          {groupInfo && groupInfo?.groupName}
        </Typography>

        {/* Empty box for right side spacing */}
        <Box sx={{ width: '40px' }} />
      </Box>
      <Box sx={{ px: { xs: 2, sm: 10 } }}>
        <Box
          sx={{
            background: '#606F8C26',
            borderRadius: '16px',
            padding: '20px',
            width: '100%',
            maxWidth: '1200px',
            margin: 'auto',
            color: 'white',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
            maxHeight: '400px',
            overflowY: 'scroll',
            position: 'relative',
            zIndex: 1,
            top: '20px',

            /* Hide scrollbar */
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {groupInfo && groupInfo?.profileIds?.length > 0 ? (
            groupInfo?.profileIds.map((profile: profileType, index: number) => (
              <Box
                className={`group-details-member ${
                  groupInfo?.profileIds?.length === index + 1
                    ? ''
                    : 'group-details-member-bordered'
                }`}
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px 0', // Padding to space out each member
                  borderBottom:
                    index !== groupInfo.profileIds.length - 1
                      ? '1px solid rgba(255, 255, 255, 0.1)'
                      : 'none', // White border between members
                }}
              >
                <Box className="group-details-profile-pic">
                  <img
                    className="group-details-profile-img"
                    src={
                      profile?.profilePic
                        ? profile?.profilePic
                        : './profile-img/placeholder-profile-img.png'
                    }
                    alt={profile?.firstName}
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                    }} // Added styling for image
                  />
                </Box>
                <Box
                  className="group-details-profile-info"
                  sx={{ marginLeft: '10px' }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: '#FFFFFFA6', textAlign: 'left' }}
                  >
                    {profile?.userId?.role}
                  </Typography>
                  <Typography variant="body1" sx={{ textAlign: 'left' }}>
                    {profile?.firstName} {profile?.lastName}
                  </Typography>
                </Box>
              </Box>
            ))
          ) : (
            <DataUnavailable description="No record found" />
          )}
        </Box>
      </Box>
    </StyledBgContainer>
  );
};

export default GroupDetails;
